import React, { Component } from 'react'
import Equation from "./Equation";

const MCQuestion = ({qid, question_answers, handleCheck}) =>{


    console.log(question_answers[qid].test_questions_options)

    return(
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
        {question_answers[qid].test_questions_options.map(
          ({ id, name, media, option_img }, i) => (
            <div key={i} onClick={() => handleCheck(id)} className={question_answers[qid].question_option_id === id ? 'gradient2' : 'gradient1'}>
              <div className="qNo"><p style={{ margin: '0.2em 0' }}>{i + 1}</p></div>
              <div style={{ paddingLeft: '30px', paddingRight: '20px' }}>
                <Equation answered={question_answers[qid].question_option_id === id} math_type={question_answers[qid].math_type} equation={name}></Equation>
                {media === 1 && <img src={option_img} alt="" />}
              </div>
            </div>
          )
        )}
      </div>
    )

}

export default MCQuestion;